// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nowrap[data-v-2df1908e]{white-space:nowrap;width:1%}", ""]);
// Exports
module.exports = exports;
